import { render, staticRenderFns } from "./edit-question.vue?vue&type=template&id=e3adde82"
import script from "./edit-question.vue?vue&type=script&lang=js"
export * from "./edit-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports